import { ApiEndPoint } from '@/domains/api/api.entity';
import type { NotificationApiResponse } from '@/domains/notification/notification.entity';
import { apiRequest } from './apiRequest';

/**
 * Implementación de la lógica para llamar al API de notificaciones pendientes
 */
class NotificationApiService {
  /**
   * Obtiene las notificaciones pendientes del usuario autenticado
   * @returns Respuesta con array de tipos de notificaciones pendientes
   */
  // async getPendingNotifications(): Promise<PendingNotificationsResponse> {
  //   const notificationsResponse =
  //     await apiRequest.get<PendingNotificationsResponse>({
  //       route: ApiEndPoint.PENDING_NOTIFICATIONS,
  //     });
  //
  //   return notificationsResponse;
  // }

  async getNotifications(
    cod_funcionario: number,
  ): Promise<NotificationApiResponse> {
    const notificationsResponse = await apiRequest.get<NotificationApiResponse>(
      {
        route: ApiEndPoint.NOTIFICATION,
        param: `${cod_funcionario}/indicadores-riesgo`,
      },
    );

    return notificationsResponse;
  }
}

export const notificationApiService = new NotificationApiService();
